module.exports = __webpack_public_path__ + "static/media/rj_result_scooter4.7032ee9e.png";